import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { BuddyInfoReqProps, getBuddyDetailstRequest } from './ViewProfileAPI';
import { RootState } from '../../../store';

// Define a type for the slice state

export interface PersonProp {
  email: string;
  helpProspectCount: number;
  smallProfileUrl: string;
  banner: {
    imageUrl: string;
    videoUrl: string;
  };
  country: { code: string; name: string; flagUrl: string };
  courseInfo: { displayName: string; courseLevel: string };
  description: string;
  firstName: string;
  displayName: string;
  interests: [{ code: string; url: string; name: string }];
  languages: [];
  largeProfileUrl: string;
  lastName: string;
  mediumProfileUrl: string;
  programme: string;
  rating: string | undefined;
  school: string;
  type: string;
  year: string;
  introVideoUrl?: string;
}

export interface RatingsProps {
  prospectName?: string;
  ratings?: number;
  comment?: string;
  createdDate?: string;
}

interface UniversityBuddyListResponseProp {
  buddyViewFetchStatus: string;
  isFetchingBuddyView: boolean;
  buddyView: {
    profile?: PersonProp;
    replyTime: { unit: string; count: number };
    helpProspectCount: number;
    profileLink: string;
    ratings?: [];
    badges?: [];
    avgResponseTimeInMinutes: number;
  };
}

// Define the initial state using that type
const initialState: UniversityBuddyListResponseProp = {
  buddyViewFetchStatus: 'init',
  buddyView: {
    profile: undefined,
    replyTime: { unit: 'MIN', count: 0 },
    helpProspectCount: 0,
    profileLink: '',
    ratings: [],
    badges: [],
    avgResponseTimeInMinutes: 0,
  },
  isFetchingBuddyView: false,
};

export const fetchBuddyDetailsById = createAsyncThunk(
  'get/buddy/details/id',
  async (fetchBuddyReq: BuddyInfoReqProps) => {
    return await getBuddyDetailstRequest(fetchBuddyReq);
  }
);

// Then, handle actions in your reducers:
const ViewProfileSlice = createSlice({
  name: 'getBuddyDetailsByID',
  initialState: initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    clearBuddyView(state) {
      state.isFetchingBuddyView = false;
      state.buddyViewFetchStatus = '';
      state.buddyView = {
        profile: undefined,
        replyTime: { count: 0, unit: '' },
        helpProspectCount: 0,
        profileLink: '',
        avgResponseTimeInMinutes: 0,
      };
    },
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(fetchBuddyDetailsById.pending, (state) => {
        state.buddyViewFetchStatus = 'pending';
        state.isFetchingBuddyView = true;
      })
      .addCase(fetchBuddyDetailsById.fulfilled, (state, action) => {
        // Add user to the state array
        state.buddyViewFetchStatus = 'success';
        state.isFetchingBuddyView = false;
        state.buddyView = action.payload;
      })
      .addCase(fetchBuddyDetailsById.rejected, (state) => {
        state.buddyViewFetchStatus = 'failed';
        state.isFetchingBuddyView = false;
      });
  },
});

export const { clearBuddyView } = ViewProfileSlice.actions;

export const getBuddyViewSelector = (state: RootState) => state.getBuddyViewDetails;

export default ViewProfileSlice.reducer;
